import request from '../_helpers/request';
import axios from 'axios'; 

export const aliyunVerifyService = {
    ValidateAliyunVerify
};

function ValidateAliyunVerify(csessionid, sig,ncToken) {
    var url = 'https://e.adsale.com.hk/vreg/webapi/ValidateAliyunVerify?csessionid=' + encodeURIComponent(csessionid) + '&sig=' + encodeURIComponent(sig) + '&ncToken=' + encodeURIComponent(ncToken);
    console.log(url)
    return request.post(url)
    .then(res => {
        return res
    })
}